export default {
    state: {
        products: null,
        productsMeta: null,

        productsCategories: null,
    },
    mutations: {
        SET_PRODUCTS_DATA(state, payload){
            state.products = payload.data;
            state.productsMeta = payload.meta;
        },
        ADD_TO_PRODUCTS(state, product){
            state.products.push(product);
        },
        UNSHIFT_PRODUCTS(state, product){
            state.products.unshift(product);
        },
        DELETE_FROM_PRODUCTS(state, id){
            state.products = state.products.filter(product=>product.id!==id);
        },
        UPDATE_PRODUCT_DATA(state, data){
            if (state.products){
                state.products = state.products.map(item=>{
                    if (item.id === data.id){
                        Object.assign(item, data);
                    }
                    return item;
                });
            }
        },
        SET_PRODUCTS_CATEGORIES(state, categories){
            state.productsCategories = categories;
        }
    },
    actions: {
        getProducts({commit}, payload){
            let url = '/products?v=1';

            if (payload && payload.page){
                url += `&page=${payload.page}`
            }
            if (payload && payload.query){
                url += `&query=${payload.query}`
            }

            return window.axios.get(url).then(response=>{
                commit('SET_PRODUCTS_DATA', response.data);
                commit('SET_PRODUCTS_CATEGORIES', response.data.categories);
            });
        },
        createProduct({commit}, payload){
            let url = '/products';
            return window.axios.post(url, payload.data).then(response=>{
                commit('UNSHIFT_PRODUCTS', response.data.data);
            });
        },
        editProduct({commit}, payload){
            let url = '/products/' + payload.data.id;
            return new Promise((resolve, reject)=>{
                window.axios.put(url, payload.data.data).then(response=>{
                    commit('UPDATE_PRODUCT_DATA', response.data.data);
                    resolve(response);
                }).catch(e=>{
                    reject(e);
                });
            })
        },
        addToRelatedProducts({commit}, payload){
            let url = '/products/' + payload.data.id + '/related/add';
            return new Promise((resolve, reject)=>{
                window.axios.post(url, payload.data.data).then(response=>{
                    commit('UPDATE_PRODUCT_DATA', response.data.data);
                    resolve(response);
                }).catch(e=>{
                    reject(e);
                });
            })
        },
        removeFromRelatedProducts({commit}, payload){
            let url = '/products/' + payload.data.id + '/related/remove';
            return new Promise((resolve, reject)=>{
                window.axios.post(url, payload.data.data).then(response=>{
                    commit('UPDATE_PRODUCT_DATA', response.data.data);
                    resolve(response);
                }).catch(e=>{
                    reject(e);
                });
            })
        },
        newProductVariant(context, payload){
            let url = `/products/variants`;
            return new Promise((resolve, reject)=>{
                window.axios.post(url, payload.data).then((response)=>{
                    resolve(response);
                }).catch(e=>{
                    reject(e);
                });
            })
        },
        editProductVariant(context, payload){
            let url = `/products/variants/${payload.data.id}`;
            return new Promise((resolve, reject)=>{
                window.axios.put(url, payload.data.data).then((response)=>{
                    resolve(response);
                }).catch(e=>{
                    reject(e);
                });
            })
        },
        uploadProductPhotos(context, payload){
            let url = `/products/variants/${payload.id}/photos`;
            return new Promise((resolve, reject)=>{
                window.axios.post(url, payload.data, {headers: {'Content-Type': 'multipart/form-data'}}).then((response)=>{
                    resolve(response);
                }).catch(e=>{
                    reject(e);
                });
            })
        },
        deleteProductPhoto({commit}, payload){
            let url = '/products/photos/' + payload.data.id;
            return new Promise((resolve, reject)=>{
                window.axios.delete(url).then((response)=>{
                    resolve(response);
                }).catch(e=>{
                    reject(e);
                });
            })
        },
        deleteProduct({commit}, payload){
            let url = '/products/' + payload.data.id;
            return window.axios.delete(url).then(response=>{
                commit('DELETE_FROM_PRODUCTS', payload.data.id);
            });
        },
        deleteProductVariant({commit}, payload){
            let url = '/products/variants/' + payload.data.id;
            
            return new Promise((resolve, reject)=>{
                window.axios.delete(url).then((response)=>{
                    resolve(response);
                }).catch(e=>{
                    reject(e);
                });
            })
        },
    }
}